import React, { useEffect, useState } from 'react'
import { Typography, MenuItem, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import LiquidSelect from '@src/components/LiquidSelect'
import { CategoryModifications } from '@src/types/graphql-types'
import { ModificationTypes } from '../../enum'

interface ModificationDropDownBaseBiTubeProps {
  modificationType: ModificationTypes
  disabled?: boolean
  title: React.ReactNode
  modifications: CategoryModifications[]
  onChange?: (e: string) => void
  value?: string
}

const useStyle = makeStyles((theme: Theme) => {
  return {
    titleStyle: {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(20),
    },
  }
})

const ModificationDropDownBaseBiTube: React.FC<
  ModificationDropDownBaseBiTubeProps
> = ({ modificationType, disabled, title, modifications, onChange, value }) => {
  const classes = useStyle()
  const modFirstEntryDefaultMessage =
    modificationType === ModificationTypes.FiveMod
      ? 'None'
      : 'Add Internal Modification'

  const firstMod: any = []
  if (modificationType === ModificationTypes.InternalMod) {
    firstMod.push({
      displayName: modFirstEntryDefaultMessage,
      order: 0,
      value: '',
    })
  }
  const modificationList = firstMod.concat(
    modifications
      .map((modification) => ({
        displayName: modification.name,
        order: modification.order ? parseInt(modification.order) : 0,
        value: modification.value,
      }))
      .sort((a, b) => a.order - b.order)
  )
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    if (modificationType === ModificationTypes.InternalMod) {
      setSelectedValue('')
    } else {
      setSelectedValue(value)
    }
  }, [value, modifications])

  const onModificationChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const newValue = e.target.value as string
    setSelectedValue(newValue)
    onChange && onChange(newValue)
  }
  const renderModValue = (v: any) => {
    const selectedMod = modificationList.find((mod) => mod?.value === v)
    return selectedMod?.displayName
      ? selectedMod.displayName
      : modFirstEntryDefaultMessage
  }
  return (
    <>
      <Typography component="span" data-scrub className={classes.titleStyle}>
        {title}
      </Typography>
      <LiquidSelect
        filled
        onChange={onModificationChange}
        value={selectedValue}
        size={'large'}
        displayEmpty
        disabled={disabled}
        renderValue={() => renderModValue(selectedValue)}
      >
        {modificationList.map((mod) => (
          <MenuItem key={mod?.value} value={mod?.value}>
            {mod.displayName}
          </MenuItem>
        ))}
      </LiquidSelect>
    </>
  )
}

export default ModificationDropDownBaseBiTube
